import { useNavigate } from 'react-router';
import { Box, Button, Container, Paper, Typography } from '@mui/material';

export default function NotFoundPage() {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    return (
        <Container
            maxWidth="md"
            sx={{
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                display: 'flex',
            }}
        >
            <Paper
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    padding: 5,
                    gap: 3,
                }}
            >
                <Typography variant="h2">404 Not Found</Typography>
                <Typography variant="h5">
                    Whoopsie looks like this page does not exist!
                </Typography>
                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={goBack}
                    >
                        Go Back
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}
